import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UserProfileState } from './userProfile.reducer';

// Selector to access the entire user profile feature state
export const selectUserProfileState = createFeatureSelector<UserProfileState>('userProfile');

export const selectUserProfileData = createSelector(
  selectUserProfileState,
  (state: UserProfileState) => state.data
);

export const selectUserProfileError = createSelector(
  selectUserProfileState,
  (state: UserProfileState) => state.error
);

export const selectUserProfileSuccess = createSelector(
  selectUserProfileState,
  (state: UserProfileState) => state.data
);

export const selectUpdateSuccess = createSelector(
  selectUserProfileState,
  (state: UserProfileState) => state.profile
);

export const selectUpdateFailure = createSelector(
  selectUserProfileState,
  (state: UserProfileState) => state.error
);

export const selectSetupLoading = createSelector(
  selectUserProfileState,
  state => state.loading
);

export const selectSetupMessage = createSelector(
  selectUserProfileState,
  state => state.message
);

export const selectSetupError = createSelector(
  selectUserProfileState,
  state => state.error
);

export const selectUpdateUserProfileSuccess = createSelector(
  selectUserProfileState,
  (state: UserProfileState) => state.data
);

export const selectUpdateUserProfileError = createSelector(
  selectUserProfileState,
  (state: UserProfileState) => state.profile
);
